export var PaymentType;
(function (PaymentType) {
    PaymentType["ONETIME"] = "ONETIME";
    PaymentType["SUBSCRIPTION"] = "SUBSCRIPTION";
    PaymentType["VOUCHER"] = "VOUCHER";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=payment-type.enum.js.map